import { useGetAllPredefinedCrossClientQueriesQuery } from '../../../store/crossClient/crossClient'
import { type PredefinedCrossClientQuery } from '../../../models/CrossClient'

export interface RecommendedCrossClientQueries {
  queries: PredefinedCrossClientQuery[]
  loading: boolean
  isError: boolean
}

export const useRecommendedCrossClientQueries = (options?: { skip?: boolean }): RecommendedCrossClientQueries => {
  const { data, isLoading, isError } = useGetAllPredefinedCrossClientQueriesQuery(undefined, { skip: options?.skip })

  return { queries: data?.data ?? [], loading: isLoading, isError }
}
